export default "__VITE_ASSET__DXy0ppvL__"